import styled from "@emotion/styled";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import SuccessImage from "assets/images/success.png";
import { Button } from "components/UI";

const Image = styled.img`
  height: 140px;
  width: auto;
  object-fit: contain;
`;

export const SuccessModal = ({
  open,
  onClose,
  title = "ተልኳል!",
  message = "እንኳን ደስ አሎት ሪፖርቱን በተሳካ ሁኔታ ልከዋል።",
  buttonText = "ዝጋ"
}) => {
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogContent>
        <Stack spacing={2}>
          <Image src={SuccessImage} alt="success" />
          <Stack spacing={1}>
            <Typography variant="h6" alignSelf="center">
              {title}
            </Typography>
            <Typography variant="body1" alignSelf="center">
              {message}
            </Typography>
          </Stack>
          <Button onClick={onClose}>{buttonText}</Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
